import { Pipe, PipeTransform } from '@angular/core';
import {Integration} from '@app/views/admin/application-settings/models/integration.model';
import {IntegrationTask} from '@app/views/admin/application-settings/models/integration-task.model';
import {DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';
import {EduToneEntityTitlePipe} from '@app/core/pipes/roster-entity-pipes/edutone-entity-title.pipe';

@Pipe({
    name: 'ngcEntityTitle'
})
export class EntityTitlePipe implements PipeTransform {

    constructor(private eduToneEntityTitlePipe: EduToneEntityTitlePipe) {}

    transform(task: IntegrationTask, ds: string, integration: Integration): string {
        let result = task[ds + 'Type'];
        if (integration[ds].dataSourceType === DataSourceType.EduTone) {
            result = this.eduToneEntityTitlePipe.transform(result);
        } else {
            if (integration[ds].dataSourceType === DataSourceType.SFTP) {
                result = task.csvFileName + '.csv';
            }
        }
        return result;
    }

}
